import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileText } from '@fortawesome/free-solid-svg-icons';
import { ProcessoInfo, TipoProcesso } from '../types';

interface ProcessInfoProps {
  processoInfo: ProcessoInfo;
  onProcessoChange: (processoInfo: ProcessoInfo) => void;
}

const TIPOS_PROCESSO: { value: TipoProcesso; label: string }[] = [
  { value: 'Processo de Filhos', label: 'Processo de Filhos' },
  { value: 'Processo de Netos', label: 'Processo de Netos' },
  { value: 'Processo de Bisneto(a) Paralelo', label: 'Processo de Bisneto(a) Paralelo' },
  { value: 'Processo de Bisneto(a)', label: 'Processo de Bisneto(a)' },
  { value: 'Processo de Trineto(a)', label: 'Processo de Trineto(a)' },
];

export const ProcessInfo: React.FC<ProcessInfoProps> = ({ processoInfo, onProcessoChange }) => {
  const handleChange = (field: keyof ProcessoInfo, value: string) => {
    onProcessoChange({
      ...processoInfo,
      [field]: value,
    });
  };

  return (
    <div className="card process-info">
      <div className="card-header">
        <FontAwesomeIcon icon={faFileText} className="card-icon" size={24} />
        <h2>Informações do Processo</h2>
      </div>
      
      <div className="form">
        <div className="form-group">
          <label htmlFor="tipoProcesso">Tipo do Processo:</label>
          <select
            id="tipoProcesso"
            value={processoInfo.tipoProcesso}
            onChange={(e) => handleChange('tipoProcesso', e.target.value as TipoProcesso)}
            className="form-select"
          >
            <option value="">Selecione o tipo de processo</option>
            {TIPOS_PROCESSO.map((tipo) => (
              <option key={tipo.value} value={tipo.value}>
                {tipo.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="nomeClienteApp">Nome do Cliente:</label>
          <input
            type="text"
            id="nomeClienteApp"
            value={processoInfo.nomeClienteApp}
            onChange={(e) => handleChange('nomeClienteApp', e.target.value)}
            placeholder="Conforme o App"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="atividadeEnvio">Atividade de envio:</label>
          <input
            type="text"
            id="atividadeEnvio"
            value={processoInfo.atividadeEnvio}
            onChange={(e) => handleChange('atividadeEnvio', e.target.value)}
            placeholder="#AAAAAA"
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
};
